<ion-button (click)="downloadDocument()" [disabled]="disabled" [fill]="fill" class="download-document-button"
            expand="block">
  <ion-icon slot="start" src="/assets/icon/icon_pdf.svg" />
  {{ downloadButtonText }}
</ion-button>
